var _mask, _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginMypageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 10,
    fill: "#474A60"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6057 24.5C11.3265 24.5 11.1001 24.2597 11.1001 23.9633V23.4371C11.1001 22.2561 11.5013 20.1499 11.9475 19.2875C12.1487 18.8986 12.3674 18.5433 12.5811 18.2337C12.6087 18.1937 12.6188 18.1076 12.5619 18.0329C11.9582 17.239 11.5964 16.2282 11.5964 15.1292C11.5964 12.5719 13.5516 10.5 15.9622 10.5C18.3728 10.5 20.3281 12.5719 20.3281 15.1292C20.3281 16.1437 20.0197 17.0834 19.497 17.8465C19.4454 17.922 19.4573 18.006 19.4862 18.0459C19.741 18.3968 20.0097 18.8179 20.2527 19.2875C20.6989 20.1499 21.1001 22.2561 21.1001 23.4371V23.9633C21.1001 24.2597 20.9513 24.5013 20.6733 24.5H15.9622H11.6057Z",
    fill: "#474A60"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 9.25,
    stroke: "#474A60",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginMypageIcon);
export default __webpack_public_path__ + "static/media/login_mypage_icon.222f6b36dbcc50b02460b75d860aadd9.svg";
export { ForwardRef as ReactComponent };